export enum CreateOfferTestIds {
  PREVIEW_BTN = 'create_offer_preview_btn',
  SELECT_QUANTITY = 'create_offer_quantity_selector',
  SELECT_DEADLINE = 'create_offer_deadline_selector',
  CURRENCY_SELECTOR = 'create_offer_currency_selector',
  SELECT_QUANTITY_ITEM = 'create_offer_quantity_selector_item',
}
